import React, {Component} from 'react';

const SortIcon = ({sortDirection}) => {
    if (sortDirection === 'asc') {
        return <i className="fa fa-fw fa-sort-asc"></i>;
    }

    if (sortDirection === 'desc') {
        return <i className="fa fa-fw fa-sort-desc"></i>;
    }

    return null;
}

export default class SortableTableHeading extends Component {
    constructor(props) {
        super(props);

        this.sortStates = [
            null,
            'asc',
            'desc',
        ];

        this.onHeadingClick = this.onHeadingClick.bind(this);
    }

    onHeadingClick() {
        const {sortDirection, onClick} = this.props;
        let currentStateIndex = this.sortStates.indexOf(sortDirection);
        if (currentStateIndex === -1) {
            currentStateIndex = 0;
        }
        const nextStateIndex = (currentStateIndex + 1) % this.sortStates.length;
        onClick(this.sortStates[nextStateIndex]);
    }

    render() {
        const {children, isSortEnabled, sortDirection} = this.props;

        return (
            <th className="cursor-pointer" onClick={this.onHeadingClick}>
                {children}
                <SortIcon sortDirection={isSortEnabled ? sortDirection : null}/>
            </th>
        );
    }
}